import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_create_sales_orders_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { orders: $frontendTypes.FootprintApiManager.input_create_sales_order[] }): Promise<{ orders?: $frontendTypes.FootprintApiManager.public_order[], errors?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orders)) {
      $missingRequiredInParams.push('\'orders\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/sales_orders/create`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

